export const AVAILABLE_COUNTRIES_CHANGED_EVENT = "veya_available_countries_changed";
const STORAGE_KEY = "veya_available_countries";

export function getAvailableCountries() {
  try {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    return Array.isArray(saved) && saved.length ? saved : ["NZ"];
  } catch {
    return ["NZ"];
  }
}

export function setAvailableCountries(countries) {
  const clean = Array.from(new Set((countries || []).filter(Boolean)));

  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify(clean.length ? clean : ["NZ"])
  );

  window.dispatchEvent(
    new CustomEvent(AVAILABLE_COUNTRIES_CHANGED_EVENT, {
      detail: clean.length ? clean : ["NZ"],
    })
  );
}